export const parseCardCrop = value => {
  if (typeof value !== 'string' || !/^\s*\d+(?:\.\d+)?\s*,\s*\d+(?:\.\d+)?(?:\s*,\s*\d+(?:\.\d+)?)?\s*$/.test(value)) return null
  const [x, y, zoom = 1] = value.split(',').map(Number)
  if (![x, y, zoom].every(Number.isFinite) || x < 0 || x > 100 || y < 0 || y > 100 || zoom < 1 || zoom > 10) return null

  return { x, y, zoom }
}

export const cropFromSelection = (meta, rect) => {
  const base = Math.min(meta.renderedWidth, meta.renderedHeight * (4 / 3))
  if (!base || !rect.width || !rect.height) return null
  const position = (offset, available) => (available > 0.001 ? Math.min(100, Math.max(0, (offset / available) * 100)) : 50)

  return [
    position(rect.x - meta.offsetX, meta.renderedWidth - rect.width),
    position(rect.y - meta.offsetY, meta.renderedHeight - rect.height),
    base / rect.width,
  ].map(value => Number(value.toFixed(6))).join(',')
}

// Use the editor's own Quill instance, not the separately installed Quill 2 package.
export const registerCardCropFormat = Quill => {
  const Image = Quill.import('formats/image')
  class CardCropImage extends Image {
    static formats(node) {
      const formats = super.formats(node)
      const crop = node.getAttribute('data-card-crop')
      if (parseCardCrop(crop)) formats['data-card-crop'] = crop

      return formats
    }

    format(name, value) {
      if (name === 'data-card-crop') {
        if (parseCardCrop(value)) this.domNode.setAttribute(name, value)
        else this.domNode.removeAttribute(name)
      } else super.format(name, value)
    }
  }
  Quill.register(CardCropImage, true)
}
